import React, { useContext, useState } from "react";
import { NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DebugContext } from "../../contexts/DebugContext";
import { TopNavContext } from "../../contexts/TopNavContext";
import User from "../../models/User";
import { INavService, NavPage } from "../../services/NavService";
import { Translator } from "../../services/TranslationService";
import { UserRight } from "../../services/WebApiClient";
import { LoginModal } from "../EditorCommon/LoginModal";
import { PasswordEditModal } from "../PasswordEditModal/PasswordEditModal";



export function TopNav(props: {
    children?: React.ReactNode;
    header: string;
}) {
    let context = useContext(TopNavContext);
    const [showModal, setShowModal] = useState<undefined | "login" | "changePassword">(undefined);
    async function login(evt: React.MouseEvent) {
        evt.preventDefault();
        setShowModal("login");
    }

    let rightSide = (context.currentUser)
        ? <RightSideWithLogin user={context.currentUser} showModal={showModal} setShowModal={setShowModal} />
        : (
            <span className="navbar-text" onClick={login} style={{ cursor: "pointer" }} >
                { context.translator("topbar login button", "login")}
            </span>
        );

    return (
        <nav className="navbar navbar-light navbar-expand-md topnav flex-row justify-content-between">
            <div className="col-4">
                <Link className="navbar-brand" to="/">
                    <img src={context.logoUrl ?? "/logo_logo.png"} alt="" style={{ height: '45px' }} />
                </Link>
            </div>
            <div className="col-4">
                <h1 className="editor-header">{props.header}</h1>
            </div>
            <div className="col-4 nav justify-content-end" >
                {rightSide}
            </div>
            <div className="">
                <div className="">
                </div>
            </div>
            {showModal === "login" && <LoginModal onLoggedIn={() => setShowModal(undefined)} onClose={() => setShowModal(undefined)} />}
            {showModal === "changePassword" && <PasswordEditModal onClose={() => setShowModal(undefined)} />}

        </nav>
    );
}


function RightSideWithLogin(props: {
    user: User,
    showModal: undefined | "login" | "changePassword",
    setShowModal: (m: undefined | "login" | "changePassword") => void
}) {
    let context = useContext(TopNavContext);
    const debugContext = useContext(DebugContext);
    function logout() {
        context.loginService.logout();
        context.navService?.navigate(NavPage.ProductLine);
    }
    function startChangePassword() {
        props.setShowModal("changePassword");
    }

    const elements: JSX.Element[] = [];

    {
        const userElements = getDropdownItems(NavPage.User.Pages,
            props.user,
            context.navService,
            context.translator
        );

        if (userElements.length > 0) {
            elements.push(...userElements);
            elements.push(<NavDropdown.Divider key="user-divider" />);
        }
    }
    {

        const adminElements = getDropdownItems(NavPage.Admin.Pages,
            props.user,
            context.navService,
            context.translator
        );

        if (adminElements.length > 0) {
            elements.push(...adminElements);
            elements.push(<NavDropdown.Divider key="admin-divider" />);
        }
    }

    {
        const debugElements: JSX.Element[] = [];

        if (props.user.userRights.find(ur => ur === UserRight.EditProducts)) {
            debugElements.push(
                <NavDropdown.Item
                    onSelect={() => debugContext.set({
                        ...debugContext.value,
                        displayExtendedProductInfo: !(debugContext.value.displayExtendedProductInfo)
                    })}
                    key="debug-ext-product-info"
                >
                    {debugContext.value.displayExtendedProductInfo && "✔"}
                    {context.translator("topbar menu debug extended product info", "Vis udvidet produkt-info")}
                </NavDropdown.Item>
            );
        }

        if (debugElements.length > 0) {
            elements.push(...debugElements);
            elements.push(<NavDropdown.Divider key="debug-divider" />)
        }
    }


    return (
        <>
            <ul className="navbar-nav">
                <li className="nav-item">
                    <NavDropdown
                        id="login-settings-dropdown"
                        title={props.user.name}
                    >
                        {elements}

                        <NavDropdown.Item onSelect={startChangePassword}>
                            {context.translator("topbar setting change password", "Skift password...")}

                        </NavDropdown.Item>
                        <NavDropdown.Item onSelect={logout}>
                            {context.translator("topbar setting logout", "Log ud")}
                        </NavDropdown.Item>
                    </NavDropdown>
                </li>
            </ul>
        </>
    );
}

function getDropdownItems(navPages: NavPage[], user: User, navService: INavService | undefined, translator: Translator): JSX.Element[] {
    const result = navPages
        .filter(page =>
            !page.requiredRights
            || page.requiredRights.every(requiredRight => user.userRights.find(ur => ur === requiredRight))
        )
        .map(page => (
            <NavDropdown.Item
                onSelect={() => navService?.navigate(page)}
                key={page.url}
            >
                {translator(page)}
            </NavDropdown.Item>
        ));
    return result;
}
